<div class="flex flex-col gap-4" data-cy="medical-prophylaxis">
  <h3 class="medical-section-title text-lg font-semibold m-0">{{ 'animalMedical.sections.prophylaxis' | transloco }}</h3>

  <div class="grid grid-cols-2 md:grid-cols-4 gap-3">
    @for (tile of [
      { status: 'overdue', count: tiles.overdue, label: 'animalMedical.prophylaxis.tiles.overdue', color: 'text-red-600' },
      { status: 'due', count: tiles.due, label: 'animalMedical.prophylaxis.tiles.due', color: 'text-orange-600' },
      { status: 'upcoming', count: tiles.upcoming, label: 'animalMedical.prophylaxis.tiles.upcoming', color: 'text-green-700' },
      { status: 'none', count: tiles.none, label: 'animalMedical.prophylaxis.tiles.none', color: 'text-gray-600' }
    ]; track tile.status) {
      <button
        type="button"
        class="border rounded-lg p-3 flex flex-col items-start gap-1 text-left cursor-pointer transition-colors"
        [ngClass]="statusFilter === tile.status ? 'border-[var(--p-primary-400)] bg-[var(--p-primary-50)]' : 'border-gray-200 hover:bg-gray-50'"
        [attr.aria-pressed]="statusFilter === tile.status"
        (click)="toggleStatusFilter($any(tile.status))"
      >
        <span class="text-2xl font-semibold" [ngClass]="tile.color">{{ tile.count }}</span>
        <span class="text-xs text-gray-600">{{ tile.label | transloco }}</span>
      </button>
    }
  </div>

  @if (!rows.length) {
    <p-message severity="info">{{ 'animalMedical.prophylaxis.empty' | transloco }}</p-message>
  } @else {
    <p-table [value]="visibleRows" dataKey="key" styleClass="p-datatable-sm" [tableStyle]="{ 'min-width': '48rem' }">
      <ng-template pTemplate="header">
        <tr>
          <th>{{ 'animalMedical.prophylaxis.columns.category' | transloco }}</th>
          <th>{{ 'animalMedical.prophylaxis.columns.type' | transloco }}</th>
          <th>{{ 'animalMedical.prophylaxis.columns.preparation' | transloco }}</th>
          <th>{{ 'animalMedical.prophylaxis.columns.administeredAt' | transloco }}</th>
          <th>{{ 'animalMedical.prophylaxis.columns.dueAt' | transloco }}</th>
          <th>{{ 'animalMedical.prophylaxis.columns.status' | transloco }}</th>
          <th class="w-12"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr>
          <td>{{ categoryLabelKey(row.category) | transloco }}</td>
          <td>{{ row.type ? (typeLabelKey(row.type) | transloco) : '–' }}</td>
          <td>
            {{ row.preparation || '–' }}
            @if (row.batchNumber) { <span class="text-xs text-gray-500">· {{ row.batchNumber }}</span> }
          </td>
          <td>{{ row.administeredAt ? (row.administeredAt | date:'dd.MM.yyyy') : '–' }}</td>
          <td>
            {{ row.dueAt ? (row.dueAt | date:'dd.MM.yyyy') : '–' }}
            @if (row.daysUntilDue !== null) {
              <span class="text-xs text-gray-500">
                ({{ (row.daysUntilDue < 0 ? 'animalMedical.prophylaxis.daysOverdue' : 'animalMedical.prophylaxis.daysLeft')
                    | transloco: { days: row.daysUntilDue < 0 ? -row.daysUntilDue : row.daysUntilDue } }})
              </span>
            }
          </td>
          <td><p-tag [severity]="statusSeverity(row.status)" [value]="statusLabelKey(row.status) | transloco" /></td>
          <td>
            <p-button size="small" [text]="true" icon="pi pi-ellipsis-v"
                      [ariaLabel]="'animalMedical.actions' | transloco"
                      (onClick)="openRowMenu(row, menu, $event)" />
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr><td colspan="7" class="text-gray-500">{{ 'animalMedical.prophylaxis.emptyFiltered' | transloco }}</td></tr>
      </ng-template>
    </p-table>
    <p-menu #menu [model]="rowMenu" [popup]="true" appendTo="body" />
  }

  <div class="flex flex-col gap-2">
    <h4 class="medical-dialog-heading">{{ 'animalMedical.prophylaxis.medication' | transloco }}</h4>
    @if (!medications.length) {
      <span class="text-sm text-gray-500">{{ 'animalMedical.prophylaxis.noMedication' | transloco }}</span>
    } @else {
      <p-table [value]="medications" dataKey="id" styleClass="p-datatable-sm" [tableStyle]="{ 'min-width': '40rem' }">
        <ng-template pTemplate="header">
          <tr>
            <th>{{ 'animalMedical.fields.preparation' | transloco }}</th>
            <th>{{ 'animalMedical.fields.dose' | transloco }}</th>
            <th>{{ 'animalMedical.fields.frequency' | transloco }}</th>
            <th>{{ 'animalMedical.prophylaxis.since' | transloco }}</th>
            <th>{{ 'animalMedical.prophylaxis.prescribedBy' | transloco }}</th>
            <th></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-medication>
          <tr>
            <td>{{ medication.preparation || '–' }}</td>
            <td>{{ medication.dose || '–' }}</td>
            <td>{{ medication.frequency || '–' }}</td>
            <td>{{ medication.administeredAt | date:'dd.MM.yyyy' }}</td>
            <td>{{ veterinarianName(medication) }}</td>
            <td>
              @if (recordIdOf(medication); as recordId) {
                <p-button size="small" [link]="true" [label]="'#' + recordId" (onClick)="goToRecord.emit(recordId)" />
              }
            </td>
          </tr>
        </ng-template>
      </p-table>
    }
  </div>
</div>
